import React, { useState, useEffect } from "react";
import {  Button} from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { useDispatch, useSelector } from "react-redux";
import { deleteStudentAction } from "../../../redux/actions/studentActions";
import Toggle from 'react-toggle'

const LeavingCertifcate = (props) => {
  const dispatch = useDispatch();
  const { loader ,studentProfileDetails  } = useSelector((state) => state.student);
  const [deleteShow, setDeleteShow] = useState(false);
  const [isProfileActive, setIsProfileActive] = useState(studentProfileDetails.isActive);
  console.log(studentProfileDetails)
  useEffect(() => {
    if(Object.keys(studentProfileDetails).length > 0){
      setIsProfileActive(studentProfileDetails.isActive)

    }
  }, [studentProfileDetails]);
  
  const deleteStudent =async()=>{
    await dispatch(deleteStudentAction({
      StudentId: studentProfileDetails.id
    },[]))
    setDeleteShow(false)
    setIsProfileActive(!isProfileActive)
  }
  const onCancel =()=>{
    console.log("Is Triggerd",isProfileActive,studentProfileDetails.isActive)
    setDeleteShow(false);
    setIsProfileActive(studentProfileDetails.isActive)
  }
  const toggleAction = ()=>{
    setDeleteShow(true)
  }
  return (
    <div className="page-wrapper">
          <div className="spacer"></div>
          {deleteShow ? (
               <SweetAlert
               warning="warning"
               showCancel
               confirmBtnText="Continue"
               confirmBtnBsStyle="info"
               title="Are you sure?"
               onConfirm={deleteStudent}
               onCancel={onCancel}
               focusCancelBtn
             >
              {isProfileActive ? "you want to settle the student ? Please contact the Head of Department" : "You want to Unsettle / Activate the student , Please contact head of department"} 
             </SweetAlert>
   
          ): null }
          <div className="row">
                <div className="col-10">
                  </div>
                <div className="col-2 text-right">
                <Toggle
                  id='cheese-status'
                  checked={isProfileActive}
                  defaultChecked={isProfileActive}
                  onChange={toggleAction} title={ isProfileActive ? "Active" : "InActive"} disabled={!studentProfileDetails.ClassRoomId}/>
                {/* <Button
                      className="btn  app-default-button btn-sm"
                      title="Settle student"
                      onClick={()=>{
                        setDeleteShow(true)
                      }}
                    >
                      <i className="fa fa-trash"></i>
                    </Button> */}
                  </div>
            </div>
            <div className="spacer"></div> 
    </div>
  );
};

export default LeavingCertifcate;
